var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../../components/actor/Actor_';
import { ChoiceOptionState } from '../../../../../classes/learnware/LearnwareEnums';
import { Aspect_ } from '../../../../../components/actor/Aspect_';
import { QuestionCorrectWrong } from '../../../../../questiontype/CorrectWrong/QuestionCorrectWrong';
import { CheckInEditMode } from './CheckInEditMode';
import { AbfragerCorrectWrongButtonIcon } from '../../CorrectWrong/AbfragerCorrectWrongButtonIcon';
import { AvailablePopover } from '../../../../../components/other/AvailablePopover';
let AbfragerMultipleChoiceOptionButton = class AbfragerMultipleChoiceOptionButton extends React.PureComponent {
    get option() {
        return this.props.option;
    }
    get app() {
        return this.option.context.app;
    }
    get optionState() {
        return this.option.optionUI.choiceOptionUIState;
    }
    get buttonClass() {
        if ([ChoiceOptionState.CorrectDone, ChoiceOptionState.CorrectPending, ChoiceOptionState.ShouldHaveBeenSelected].includes(this.optionState)) {
            return 'btn-success';
        }
        return 'btn-default';
    }
    get optionBackground() {
        if (this.optionState === ChoiceOptionState.Default && this.option.isPreselecting) {
            return 'linear-gradient(to bottom, #fcfff4 0%,#fff6ba 100%)';
        }
        return undefined;
    }
    get optionColor() {
        if ([ChoiceOptionState.CorrectDone, ChoiceOptionState.CorrectPending, ChoiceOptionState.ShouldHaveBeenSelected].includes(this.optionState)) {
            return '#FFF';
        }
        return undefined;
    }
    get optionOpacity() {
        if ([ChoiceOptionState.Wrong].includes(this.optionState)) {
            return 0.3;
        }
        return 1;
    }
    render() {
        const { option } = this.props;
        const question = option.question;
        const comp = (React.createElement(Actor_, { actor: option, structureTemplate: React.createElement(React.Fragment, null,
                false && option.context.app.appInfo.isUserCurrentlyEditing && React.createElement(CheckInEditMode, { option: option }),
                React.createElement("button", { type: "button", "data-aspect": "inner", className: this.buttonClass, style: {
                        opacity: this.optionOpacity,
                        color: this.optionColor,
                        marginTop: 36,
                        padding: '15px 30px',
                        minWidth: 170,
                        fontSize: 35,
                        verticalAlign: 'middle',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.33,
                        borderRadius: 6
                    } }, question instanceof QuestionCorrectWrong && React.createElement(AbfragerCorrectWrongButtonIcon, { option: option }))) }));
        return this.wrapCommentPopover(comp);
    }
    wrapCommentPopover(comp) {
        const option = this.props.option;
        return (React.createElement(AvailablePopover, { placement: "right", content: option.commentAspectToShow && React.createElement(Aspect_, { aspect: option.commentAspectToShow }), visible: !!option.commentAspectToShow }, comp));
    }
};
AbfragerMultipleChoiceOptionButton = __decorate([
    observer
], AbfragerMultipleChoiceOptionButton);
export { AbfragerMultipleChoiceOptionButton };
/*
.correctwrong_button {

}
.correctwrong_button.btn-success { .btn-styles(@btn-success-bg); }
.correctwrong_button.btn-success i.text-danger { color:#FFFFFF; }
.correctwrong_button.btn-success i.text-success { color:#FFFFFF; }
.correctwrong_button.btn-default:disabled  i.text-success, .correctwrong_button.btn-default[disabled]  i.text-success,
.correctwrong_button.btn-default:disabled  i.text-danger, .correctwrong_button.btn-default[disabled]  i.text-danger  {
    color:#CCCCCC;
}
.correctwrong_button:focus, .correctwrong_button:active { background-position: 0% 0% !important; }
.correctwrong_button_hover:hover, .correctwrong_button_hover_hover {
    border: 1px solid #CCC;background: linear-gradient(to bottom, #fcfff4 0%,#fff6ba 100%);
}

 */
